import {
  Box,
  HStack,
  Stat,
  StatLabel,
  StatNumber,
  Text,
  Tooltip
} from '@chakra-ui/react';
import { useLeaderboard } from 'hooks/query/useLeaderboard';
import { useWeb3React } from 'hooks/web3';
import { FC, useMemo } from 'react';
import { Crucible } from 'types';

type Props = {
  crucible: Crucible;
  rewardProgramAddress: string;
  pathMatch: boolean;
};

export const CrucibleStats: FC<Props> = ({
  crucible,
  rewardProgramAddress,
  pathMatch
}) => {
  const { chainId = 1 } = useWeb3React();
  const { data, isLoading } = useLeaderboard(
    chainId,
    rewardProgramAddress,
    crucible.id
  );

  const entry = useMemo(() => {
    if (data && data.leaderboard && data.leaderboard.length > 0) {
      return { ...data.leaderboard[0], maxRank: data.maxRank };
    }
  }, [data]);

  if (entry) {
    return (
      <Box
        p={4}
        borderRadius='lg'
        bgGradient='linear(to-r, purple.500, cyan.600)'
        sx={{ marginTop: '32px !important', position: 'relative' }}
      >
        {entry.rank && entry.rank < 4 && (
          <Box
            sx={{
              position: 'absolute',
              right: [-1, 4],
              top: -2.5,
              fontSize: 40
            }}
          >
            {entry.rank === 1 && (
              <Text sx={{ textShadow: '0px 4px 12px rgba(0, 0, 0, 20%)' }}>
                🥇
              </Text>
            )}
            {entry.rank === 2 && (
              <Text sx={{ textShadow: '0px 4px 12px rgba(0, 0, 0, 20%)' }}>
                🥈
              </Text>
            )}
            {entry.rank === 3 && (
              <Text sx={{ textShadow: '0px 4px 12px rgba(0, 0, 0, 20%)' }}>
                🥉
              </Text>
            )}
          </Box>
        )}
        <HStack>
          <Stat>
            <StatLabel>{pathMatch ? 'Rank' : 'Your Rank'}</StatLabel>
            <StatNumber fontSize={[16, 24]}>
              {entry.rank}/{entry.maxRank}
            </StatNumber>
          </Stat>
          <Stat display={['none', 'block']}>
            <StatLabel>Points</StatLabel>
            <StatNumber fontSize={[16, 24]}>
              <Tooltip label={entry.level} placement='bottom' hasArrow>
                {entry.level < 1
                  ? entry.level.toFixed(5)
                  : entry.level.toFixed(2)}
              </Tooltip>
            </StatNumber>
          </Stat>
          <Stat>
            <StatLabel>Duration</StatLabel>
            <StatNumber fontSize={[16, 24]}>
              {entry.totalDuration.toFixed(0)} days
            </StatNumber>
          </Stat>
          <Stat>
            <StatLabel>Avg. Stake</StatLabel>
            <StatNumber fontSize={[16, 24]}>
              <Tooltip label={entry.totalAmount} placement='bottom' hasArrow>
                {entry.totalAmount < 1
                  ? entry.totalAmount.toFixed(5)
                  : entry.totalAmount.toFixed(2)}
              </Tooltip>
            </StatNumber>
          </Stat>
        </HStack>
      </Box>
    );
  } else if (!isLoading) {
    return (
      <Box
        p={2}
        fontSize='sm'
        color='gray.300'
        borderRadius='lg'
        backgroundColor='gray.900'
        sx={{ marginTop: '32px !important', position: 'relative' }}
      >
        <Text>
          {pathMatch
            ? 'Crucible has not participated in this reward program.'
            : 'Your rank will be displayed here once you participate in this reward program for more than a day.'}
        </Text>
      </Box>
    );
  } else {
    return <></>;
  }

  // return null;
};
